export const pexelsImages = {
  hero: "https://images.pexels.com/photos/9594419/pexels-photo-9594419.jpeg?auto=compress&cs=tinysrgb&w=1400",
  detail: "https://images.pexels.com/photos/6801192/pexels-photo-6801192.jpeg?auto=compress&cs=tinysrgb&w=900",
  sampleOne: "https://images.pexels.com/photos/6373839/pexels-photo-6373839.jpeg?auto=compress&cs=tinysrgb&w=1200",
  sampleTwo: "https://images.pexels.com/photos/9594430/pexels-photo-9594430.jpeg?auto=compress&cs=tinysrgb&w=1200",
  galleryOne: "https://images.pexels.com/photos/9594502/pexels-photo-9594502.jpeg?auto=compress&cs=tinysrgb&w=1200",
  galleryTwo: "https://images.pexels.com/photos/7956851/pexels-photo-7956851.jpeg?auto=compress&cs=tinysrgb&w=900",
};

export const pexelsGallery = [
  {
    id: 101,
    title: "Packaging Presentation",
    category: "Portfolio",
    description: "Branded box presentation with premium tag finishing.",
    image_url: pexelsImages.hero,
  },
  {
    id: 102,
    title: "Mockup Card Study",
    category: "Portfolio",
    description: "Minimal brand-card mockup for clean product launches.",
    image_url: pexelsImages.detail,
  },
  {
    id: 103,
    title: "Stationery Layout",
    category: "Portfolio",
    description: "Print-ready card composition for identity systems.",
    image_url: pexelsImages.sampleOne,
  },
  {
    id: 104,
    title: "Packaging Application",
    category: "Portfolio",
    description: "Hands-on packaging application for retail-ready presentation.",
    image_url: pexelsImages.sampleTwo,
  },
  {
    id: 105,
    title: "Wrap Finish Preview",
    category: "Portfolio",
    description: "Protected package layout with warm premium studio lighting.",
    image_url: pexelsImages.galleryOne,
  },
  {
    id: 106,
    title: "Material Surface",
    category: "Portfolio",
    description: "Natural material texture for clean frontend feature imagery.",
    image_url: pexelsImages.galleryTwo,
  },
];
